// extracted by mini-css-extract-plugin
export default {"giftRecordsPage":"GiftRecordsPage_giftRecordsPage__qEu21"};